import menuLogo from '../../../assets/menu-logo.svg';
import { ReactComponent as SteeringWheelLogo } from '../../../assets/steering-wheel.svg';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';

export default {
  menuLogo,
  sidebarOptions: [
    {
      id: 'driver',
      labelStringId: 'driverExperience',
      path: '/driver',
      disabled: false,
      permissions: ['*', 'driver-exp'],
      icon: <SteeringWheelLogo />,
    },
    {
      id: 'tickets',
      labelStringId: 'viewTickets',
      path: '/ticket-list',
      permissions: ['*', 'tickets-view'],
      permissionsSKU: ['deliveries-driver'],
      icon: <ReceiptOutlinedIcon />,
    },
    {
      id: 'active-ticket',
      labelStringId: 'viewActiveTicket',
      path: '/active-ticket',
      permissions: ['*', 'tickets-view'],
      permissionsSKU: ['deliveries-driver'],
      icon: <GpsFixedIcon />,
    },
  ],
};
